import React from "react";

export default () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.258 9.022c-1.104-3.786-4.639-6.555-8.782-6.555S3.842 5.236 2.738 9.022m18.778-3.24l-1.258 3.24-3.126-1.214M2.765 14.126c1.104 3.786 4.639 6.555 8.782 6.555s7.634-2.769 8.738-6.555m-18.778 3.24l1.258-3.24L5.89 15.34"
      stroke="#4A4A4A"
      strokeLinecap="square"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);
